import React from "react";
import './Notification.scss';
import INotificationState, { INotificationProps } from "./Notification.models";
import NotificationTypes from "../../../models/interfaces/profile/NotificationTypes";

export default class Notification extends React.PureComponent<INotificationProps, INotificationState> {

  constructor(props: any) {
    super(props);

    this.state = {
      display:'block'
    }
  }

  renderTheme(NotificationType: NotificationTypes) {
    switch (NotificationType) {
      case NotificationTypes.Warning:
        return "notify-warning";
      case NotificationTypes.Danger:
        return "notify-danger";
      case NotificationTypes.Successfully:
        return "notify-success";
      default:
        return "notify-warning";
    }
  }

  render(): React.ReactNode {
    let { display } = this.state;
    let { notification, close, isVisibleFooter } = this.props;
    let content;

    content = (
        <>
            <div
              style={{
                display: display,
                color: notification.fontColor !== null ? notification.fontColor : "",
                backgroundColor: notification.backgroundColor != null? notification.backgroundColor: "",
              }}
              className= {'notify ' + (!notification.isCustomTheme? this.renderTheme(notification.Theme): "")}
            >
                <div className="col-12">
                    <div className="header">
                        <div className="col-11">
                            <label style={{fontSize: '17px'}}>
                                {notification.title}
                            </label>
                        </div>
                        <i className={'mdi ' + (notification.icon? notification.icon : 'mdi-alert') + ' mdi-18px'}></i>
                    </div>
                    <div className="col-12 body">
                        <label style={{fontSize: notification.fontSize !== null || notification.fontSize < 12 || notification.fontSize > 20 ? 14: notification.fontSize+'px'}}>
                            {notification.description}
                        </label>
                    </div>
                    { notification.link !== null ?(
                      <div dir="ltr" className="col-12">
                        <a href={notification.link?? ''}>{notification.link}</a>
                      </div>
                    ): (<></>)}
                    <div className="col-12 tk-text-left">
                    {isVisibleFooter ? <div>
                      <button onClick={() => close(notification.id)}  className="btn btn-link noticet">متوجه شدم</button>
                    </div> : <></>}
                </div>
               </div>
            </div>
        </>
    );

    return (
      <>
        <div>{content}</div>
      </>
    );
  }
}
